import { useEffect, useState } from 'react';
import { ProviderModel } from '../../../data/entities';

export const useProviderSelection = (
  onSelectProvider: (provider: ProviderModel) => void,
  providers: ProviderModel[],
  onSelectAnyProvider?: () => void,
  showAnyProvider?: boolean
) => {
  const [selectedProviderId, setSelectedProviderId] = useState<number | null>(null);
  const [anySelected, setAnySelected] = useState(false);

  useEffect(() => {
    if (providers.length === 1 && selectedProviderId === null && !showAnyProvider) {
      setSelectedProviderId(providers[0].id);
      onSelectProvider(providers[0]);
    }
  }, [providers.length]);

  const handleProviderClick = (provider: ProviderModel) => {
    setSelectedProviderId(provider.id);
    setAnySelected(false);
    onSelectProvider(provider);
  };

  const handleAnyProviderClick = () => {
    setSelectedProviderId(null);
    setAnySelected(true);
    onSelectAnyProvider?.();
  };

  return {
    selectedProviderId,
    anySelected,
    handleProviderClick,
    handleAnyProviderClick,
  };
};